import { useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";

export function useDeleteTaskLink() {
  const queryClient = useQueryClient();

  return async (linkId: string): Promise<boolean> => {
    const { error } = await supabase
      .from("task_links")
      .delete()
      .eq("id", linkId);

    if (error) {
      Sentry.captureException(error, {
        extra: { mutation: "useDeleteTaskLink", linkId },
      });
      toast.error("Failed to delete link. Please try again.");
      return false;
    }

    queryClient.invalidateQueries({ queryKey: queryKeys.tasks });
    return true;
  };
}

export function useDeleteSubtaskLink() {
  const queryClient = useQueryClient();

  return async (linkId: string): Promise<boolean> => {
    const { error } = await supabase
      .from("subtask_links")
      .delete()
      .eq("id", linkId);

    if (error) {
      Sentry.captureException(error, {
        extra: { mutation: "useDeleteSubtaskLink", linkId },
      });
      toast.error("Failed to delete link. Please try again.");
      return false;
    }

    queryClient.invalidateQueries({ queryKey: queryKeys.tasks });
    return true;
  };
}
